/**
 * First run.
 *
 * Two jobs, and the order matters. First say plainly what this is, because "we edit a
 * monk's recordings" is a claim that has to be made honestly and up front rather than
 * discovered. Second, get out of the way — one screen, one button.
 *
 * The disclosure is not a legal notice. It is the most interesting thing about the
 * product, so it is written as the pitch.
 */

import { updateSettings } from '../state/settings';

export function Onboarding() {
  return (
    <div class="screen">
      <div class="shell stack" style={{ flex: 1, justifyContent: 'center', gap: 'var(--gap-4)' }}>
        <div class="stack-sm">
          <span class="eyebrow">Ajahn Brahm</span>
          <h1 style={{ fontSize: 'var(--step-4)' }}>
            Real meditations, at whatever length you have.
          </h1>
        </div>

        <div class="stack-sm">
          <p>
            These are recordings of Ajahn Brahm guiding meditation on Friday nights in
            Perth, going back twenty years. Sniffs, jokes, the fans, all of it.
          </p>
          <p>
            If you have twenty-five minutes and the recording runs thirty-two, the app
            keeps every retained passage at recorded speed and in source order. It changes
            the silences between passages and generates added silence from the sound of
            the room he was actually sitting in.
          </p>
          <p class="dim" style={{ fontSize: 'var(--step--1)' }}>
            Cadence can leave out whole reminders. A contradicted duration sentence or a
            reviewed shorter opening or closing can also be left out. The preview shows
            the resulting speech before you begin.
          </p>
        </div>

        <hr />

        <p class="dim" style={{ fontSize: 'var(--step--1)' }}>
          Used with the permission of the Buddhist Society of Western Australia, who
          recorded and freely share these talks. The app is free, takes no payment and
          needs no account to sit. If you would like to give something back, there is a link to
          BSWA's own donation page in Settings.
        </p>

        <button
          class="btn btn-primary"
          style={{ width: '100%', minHeight: '3.5rem' }}
          onClick={() => updateSettings({ onboarded: true })}
        >
          Begin
        </button>
      </div>
    </div>
  );
}
